export const INN_REACH_RECALL_USER_ROUTE = 'recall-user';

export const INN_REACH_RECALL_USER_FIELDS = {
  USER_ID: 'userId',
};
